import { Box, Skeleton, Stack, Typography } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { COLORS, unit } from '@hcr/ui'

import {
  BookingDatesLoading,
  LayoutBookingOverview,
  LayoutBookingOverviewContent,
  LayoutBookingOverviewDivider,
  LayoutBookingOverviewHeader,
  LayoutBookingOverviewSection,
} from '../common'

export const BookingOverviewLoading: FC = () => {
  const { t } = useTranslation()

  return (
    <LayoutBookingOverview>
      <LayoutBookingOverviewHeader gap={unit(2)}>
        <Typography variant='bodyM'>{t('booking-overview.your-booking-at')}</Typography>
        <Skeleton width='40%' height={unit(10.5)} sx={{ bgcolor: COLORS.white }} variant='rectangular' />
      </LayoutBookingOverviewHeader>
      <LayoutBookingOverviewContent>
        <BookingDatesLoading />
        <LayoutBookingOverviewDivider />
        <LayoutBookingOverviewSection label={t('booking-overview.accommodation')}>
          <Skeleton width={unit(40)} height={unit(6)} sx={{ bgcolor: COLORS.white }} />
          <Box marginTop={unit(1)}>
            <Skeleton width={unit(25)} height={unit(5.5)} sx={{ bgcolor: COLORS.white }} />
          </Box>
        </LayoutBookingOverviewSection>
        <LayoutBookingOverviewDivider />
        <LayoutBookingOverviewSection label={t('booking-overview.booking-status')}>
          <Skeleton width={unit(40)} height={unit(6)} sx={{ bgcolor: COLORS.white }} />
        </LayoutBookingOverviewSection>
        <LayoutBookingOverviewSection label={t('booking-overview.payment-status')}>
          <Skeleton width={unit(40)} height={unit(6)} sx={{ bgcolor: COLORS.white }} />
        </LayoutBookingOverviewSection>
        <Stack
          height={unit(13)}
          sx={{ border: `${unit(0.5)} solid ${COLORS.white}` }}
          alignItems='center'
          justifyContent='center'
        >
          <Skeleton width='30%' height={unit(5)} sx={{ bgcolor: COLORS.white }} variant='rectangular' />
        </Stack>
      </LayoutBookingOverviewContent>
    </LayoutBookingOverview>
  )
}
